
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/internet/[...path]",
      function () {
        return require("private-next-pages/internet/[...path].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/internet/[...path]"])
      });
    }
  